/**
 * 个人中心-上传头像弹窗
 * created by chenhao 2017-12-5
 */
"use stricted";
angular.module("uploadHeaderModule", [])
    .controller("uploadHeaderCtrl", ['$scope', '$rootScope','$modalInstance', 'item', 'Upload','httpService', 'modalDialog',function($scope, $rootScope,$modalInstance, item, Upload,httpService,modalDialog) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
            	changeHeader:false
            };
        }
        function initData() {
            $scope.headPic = item.url;
        }
        /**
         * [changeHeadPortrait description]  更换头像
         * @param  {[type]} files    [description]
         * @param  {[type]} file     [description]
         * @param  {[type]} newFiles [description]
         * @return {[type]}          [description]
         */
        $scope.changeHeadPortrait = function(files, file, newFiles){
            // $scope.headPic = resp.data.imgSrc;
            var resp = angular.copy(item.rest)
            $scope.params = {
                serviceid: 'mlf_extuser',
                methodname: 'saveUserHead',
                UserHead: [{
                    "appFile": resp.data.imgName,
                    "appDesc": resp.data.imgName,
                    "PERPICURL": resp.data.imgSrc,
                }],
            };
            $scope.params.UserHead = JSON.stringify($scope.params.UserHead);
        }
        // $scope.changeHeadPortrait = function(files, file, newFiles) {
        //     var imgType = ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
        //         fileType = newFiles[0].name.substr(newFiles[0].name.lastIndexOf('.') + 1).toLowerCase();
        //     if (imgType.indexOf(fileType) < 0) {
        //         modalDialog.alertType('格式不支持', '', 'warning', false);
        //         return;
        //     }
        //     if(newFiles){
        //     	$scope.status.changeHeader = true;
        //     }
        //     Upload.upload({
        //         url: "/wcm/openapi/uploadImage",
        //         data: {
        //             file: newFiles[0]
        //         },
        //     }).then(function(resp) {
        //         $scope.headPic = resp.data.imgSrc;
        //         $scope.params = {
        //             serviceid: 'mlf_extuser',
        //             methodname: 'saveUserHead',
        //             UserHead: [{
        //                 "appFile": resp.data.imgName,
        //                 "appDesc": resp.data.imgName,
        //                 "PERPICURL": resp.data.imgSrc,
        //             }],
        //         };
        //         $scope.params.UserHead = JSON.stringify($scope.params.UserHead);
        //     });
        // };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close();
        };
        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.changeHeadPortrait();
            httpService.http("", $scope.params, 'get').then(function() {
                $rootScope.$emit('updateHeadPortrait');
                modalDialog.alertType('头像修改成功','','success',false,function(){
                    $scope.cancel();
                });
            });

        };
    }]);